<template>
  <div >
    <div id="app" class="container-fluid main-body fix-bottom" >
    
     <div class="modal fade" id="selectCountry" data-backdrop="static" show="true" data-keyboard="false" role="dialog" aria-labelledby="modalLabel" tabindex="-1">
        <div class="modal-dialog ">
          <div class="modal-content col-sm-offset-2 col-sm-8">
            <div class="modal-header">
              <h3 style="margin-top:0px; margin-bottom:0px;"><i class="fa fa-globe"></i> Please choose your country</h3>
            </div>

            <div class="modal-body " style="overflow:hidden;">
              <div class="well">
                <div  v-for="country in countriesList" style="margin:5px;">
                    <a @click="setCountry(country.CountryId)"  href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"> <img alt="Country" class="img img-rounded" style="width:auto;height:35px; max-height:5vh" :src="country.CountryFlag" crossOrigin="Anonymous">
                      </span><a><strong> {{country.CountryName}}</strong></a> </a>
                </div>
              </div>
              <div class="text-center">
              <a class="dropdown-toggle" href="javascript:;" @click="getNewCountry()" style="font-size:16px;" >Want your country to be listed?</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end of modal -->
   <nav class="navbar navbar-default paw hidden-xs" role="navigation ">
        <div class="container-fluid container-main " >
          
          <a href="javascript:;" @click="routerGoHome()"> <span class="navbar-brand" > <span><img alt="Dupaws Home" @mouseover="active=true" @mouseleave="active=false" id="logo" v-bind:class="{'tinted':active }" src="./components/Sitters/images/Logo_small.png" height="58"></img></span> </span></a>
                 
            <div v-if="compUserRole!=admin">
            <ul class="nav navbar-nav  navbar-right " v-if="!checkUser">
              <router-link  active-class="active" tag="li" to="/findsitters">
                   <a class="hidden-sm navbar-link"> <i class="fa fa-search"></i> Search Sitters</a>
                 </router-link>
                
                <li class="hidden-sm">
                   <a  href="https://www.dupaws.com/pub/about" class="navbar-link"> About Us</a>
                </li>
                
                 <router-link v-if="checkUser==false" active-class="active" tag="li" to="/login">
                   <a>Sign In</a>
                 </router-link>
                 <span v-if="compUserRole=='Sitter'" class="navbar-toggle pull-right bookings-button" style="padding:0px;">
                  <router-link active-class="active" tag="li" style="list-style-type:none;" to="/my-sitter-reservations">
                    <i class="icon-fix fa fa-bookmark-o"/>
                  </router-link>
                </span>

                  <span v-if="compUserRole=='Client'" class="navbar-toggle pull-right bookings-button" style="padding:0px;">
                  <router-link active-class="active" tag="li" style="list-style-type:none;" to="/my-reservations">
                    <i class="icon-fix fa fa-bookmark-o"/>
                  </router-link>
                </span>

                  <li style="list-style-type: none"><a @click="showCountries()" style="margin-right:0px;margin-left: 5px; padding-left:0px; outline: none;" href="javascript:;" ><i><img alt="Countries Selector" class="img img-rounded" style="text-indent: -9999px;width:auto;height:35px;margin-bottom:5px;outline:none;" v-if="countryDataComp.CountryFlag" :src="countryDataComp.CountryFlag" crossOrigin="Anonymous"></i> </a></li>
                 <router-link class="text-success" v-if="!doubleRoleComp" active-class="active" tag="li" to="/become-a-sitter">
                   <a style="font-weight:600"   > Become a Sitter  <i style="font-weight:600" @mouseover="heartClass=true" @mouseleave="heartClass=false" v-bind:class="{'animated bounceIn':heartClass }" class="fa fa-heart-o"></i></a>
                 </router-link>
                
            </ul>
            
            <ul class="nav navbar-nav navbar-right" v-show="checkUser">

                 <router-link v-if="compUserRole!=sitter"  class="hidden-xs hidden-sm" active-class="active" tag="li" to="/findsitters">
                   <a class="navbar-link"> <i class="fa fa-search"></i> Search Sitters</a>
                 </router-link>

                 <router-link v-if="compUserRole!=sitter"  class="hidden-xs hidden-sm" active-class="active" tag="li" to="/my-reservations">
                   <a class="navbar-link"> <i class="fa fa-bookmark-o"/> Bookings</a>
                 </router-link>
                
                <router-link v-if="compUserRole==sitter"  class="hidden-xs hidden-sm" active-class="active" tag="li" to="/dashboard/feedback-performance">
                   <a class="navbar-link"> <i class="fa fa-globe "></i> Dashboard</a>
                 </router-link>

                   <router-link v-if="compUserRole==sitter"  class="hidden-xs hidden-sm" active-class="active" tag="li" to="/my-sitter-reservations">
                   <a class="navbar-link"> <i class="fa fa-bookmark-o"></i> Bookings</a>
                 </router-link>
                
                
                <li v-if="!checkUser" style="list-style-type: none"><a @click="showCountries()" style="margin-right:0px;margin-left: 5px; padding-left:0px; outline:none;" href="javascript:;" ><i><img alt="Flag" class="img img-rounded" style="width:auto;height:35px;margin-bottom:5px;" :src="countryDataComp.CountryFlag" crossOrigin="Anonymous"></i> </a></li>
                
                <router-link v-if="compUserRole==sitter"  class="hidden-md hidden-lg bookings-button" active-class="active " tag="li" to="/my-sitter-reservations">
                   <div class="icon-fix navbar-link"> <i class=" fa fa-bookmark-o"></i></div>
                 </router-link>      
                <router-link v-if="compUserRole=='Client'"  class="hidden-md hidden-lg bookings-button" active-class="active " tag="li" to="/my-reservations">
                   <div class="icon-fix navbar-link"> <i class=" fa fa-bookmark-o"></i></div>
                 </router-link>      
                
                <li style="list-style-type: none">
                  <div  id="webNotificationDropdown" class="notification-button">
                    <Notifications :bindId="webDropdown"></Notifications>
                  </div>
                </li>

                

              <li class="dropdown pull-right">
                <a href="javascript:;" style="margin-left:3px;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" v-if="compUserName" aria-expanded="false"> <img alt="User Profile Picture" class="img img-rounded" style="width:auto;height:50px; max-height:5vh" :src="compProfilePicUrl" crossOrigin="Anonymous">
                  </span><a> {{compUserName}}</a> </a>
                <ul class="dropdown-menu dropdown-menu-right" >

                  
                  <li><a href="javascript:;" @click="goAccount()"><i class="fa fa-address-book-o"></i> Account <label v-if="mobileConfirmedComp" class="badge badge-error">1</label></a></li>
                  <li v-if="compUserRole!=sitter" class="hidden-md hidden-lg"><a href="javascript:;" @click="goFindSitters()"><i class="fa fa-search"></i> Search Sitters</a></li>
                  <li v-if="compUserRole!=sitter"><a href="javascript:;" @click="goPetsView()"><i class="fa fa-paw"></i> Pets</a></li>
                  <li v-if="compUserRole==sitter"><a href="javascript:;" @click="goCalendar()"><i class="fa fa-calendar "></i> Update Calendar </a></li>
                  <router-link class="hidden-md hidden-lg" v-if="compUserRole==sitter" tag="li" to="/dashboard/feedback-performance">

                   <a><i class="fa fa-globe"></i> Dashboard</a>
                  </router-link>
                  <router-link v-if="compUserRole==sitter" tag="li" to="/my-sitter-reservations">

                   <a><i class="fa fa-bookmark-o"/> Bookings</a>
                  </router-link>
                  <router-link v-if="compUserRole==sitter" tag="li" to="/sitter-profile-edit/about">
                   <a><i class="fa fa-address-card-o"></i> Profile Setup</a>
                  </router-link>
                  <li v-if="compUserRole!=sitter"><a href="javascript:;" @click="goMyReservations()"><i class="fa fa-bookmark-o"/> Bookings</a></li>
                  <li v-if="compUserRole!=sitter"><a href="javascript:;" @click="goFavoriteSitters()"><i class="fa fa-check-circle-o"></i> Favorite Sitters</a></li>
                  
                  <li  v-if="compUserRole=='Client' && subscriptionStatusComp==false"><a style="color:green !important" href="javascript:;" @click="goSubscribe()"><i class="fa fa-credit-card"></i> Subscribe</a></li>
                  <!-- <li  v-if="compUserRole=='Sitter' && subscriptionStatusComp==false && !singaporeComp"><a style="color:rgb(147, 111, 159) !important" href="javascript:;" @click="goSubscribe()"><i class="fa fa-paw"></i> Go Premium</a></li> -->
                  <li v-if="!doubleRoleComp"><a style="font-weight:600"  href="javascript:;" @click="goBecomeSitter()"><i style="font-weight:600" class="fa fa-heart-o"></i> Become a Sitter</a></li>
                  <li v-if="compUserRole==sitter"><a href="javascript:;" @click="goToSitterProfile()">View Public Profile</a></li>
                  <hr style="padding:0px; margin:0px">
                  <li><a href="javascript:;" @click="logout()"><i class="fa fa-sign-out"></i> Sign Out</a></li>
                </ul>
              </li>
            </ul>
            </div> <!--remove all the options if the user is admin-->
            <div v-if="compUserRole==admin">
               <ul class="nav navbar-nav navbar-right">
              
               <router-link active-class="active" tag="li" to="/charts-dashboard">
                   <a> Charts Dashboard</a>
                  </router-link>
                 <router-link active-class="active" tag="li" to="/sitters-dashboard">
                   <a> Sitters Dashboard</a>
                  </router-link>

                 <router-link active-class="active" tag="li" to="/bookings-dashboard">
                   <a> Bookings Dashboard</a>
                  </router-link>


              <li class="dropdown pull-right">
                <a href="javascript:;" style="margin-left:3px;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" v-if="compUserName" aria-expanded="false"> <img alt="User Profile Picture" class="img img-rounded" style="width:auto;height:50px; max-height:5vh" :src="compProfilePicUrl" crossOrigin="Anonymous">
                  </span><a> {{compUserName}}</a> </a>
                <ul class="dropdown-menu dropdown-menu-right" >
                 <li><a href="javascript:;" @click="goAccount()"><i class="fa fa-address-book-o"></i> Account</a></li>
               
                <router-link tag="li" to="/users-dashboard">
                   <a> Users Dashboard</a>
                  </router-link>
               <router-link tag="li" to="/charts-dashboard">
                   <a> Charts Dashboard</a>
                  </router-link>

                     <router-link tag="li" to="/sitters-dashboard">
                   <a> Sitters Dashboard</a>
                  </router-link>
                  <router-link tag="li" to="/bookings-dashboard">
                   <a> Bookings Dashboard</a>
                  </router-link>
                  
                  <router-link tag="li" to="/tickets-dashboard">
                   <a> Tickets Dashboard</a>
                  </router-link>
                  
                  <router-link tag="li" to="/email-dashboard">
                   <a> Custom Email Dashboard</a>
                  </router-link>

                  <hr style="padding:0px; margin:0px">
                  <li><a href="javascript:;" @click="logout()"><i class="fa fa-sign-out"></i> Sign Out</a></li>
                </ul>
              </li>
            </ul>
              
            </div>
        </div><!--/small and xsmall container-fluid -->
</nav>
 
 <nav class="navbar navbar-default navbar-static-top paw hidden-sm hidden-md hidden-lg">
      <div class="container">
        <div class="navbar-header">
          
          <button  type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          
          
          <span @click="closeNavbarIfOpen()" id="mobileNotificationDropdown" class="navbar-toggle pull-right notification-button" style="padding:0px;" v-show="checkUser" >
             <Notifications :bindId="mobileDropdown"></Notifications>
             
          </span>
          <span v-if="compUserRole=='Sitter'" class="navbar-toggle pull-right bookings-button" style="padding:0px;">
               <router-link active-class="active" tag="li" style="list-style-type:none;" to="/my-sitter-reservations">
                    <i class="icon-fix fa fa-bookmark-o"/>
                  </router-link>

          </span>
          <span v-if="compUserRole=='Client'" class="navbar-toggle pull-right bookings-button" style="padding:0px;">
               <router-link active-class="active" tag="li" style="list-style-type:none;" to="/my-reservations">
                    <i class="icon-fix fa fa-bookmark-o"/>
                  </router-link>

          </span>
          <span v-if="!checkUser" class="pull-right">
              <a @click="showCountries()" href="javascript:;" ><i><img alt="CF" class="img img-rounded" style="text-indent:-9999px; width:auto;height:30px; margin-top:10px; margin-right:10px; max-height:5vh" :src="countryDataComp.CountryFlag" crossOrigin="Anonymous"></i> </a>
          </span>
          
          <a href="javascript:;" @click="routerGoHome()"> <span class="navbar-brand" > <span><img alt="Dupaws Home" src="./components/Sitters/images/Logo_small.png" height="46"></img></span> </span></a>
        </div>
      
        
        <div id="navbar" class="navbar-collapse collapse" >
          <div >
          <ul class="nav navbar-nav" v-if="checkUser==true">
                  <li><a href="javascript:;" @click="goAccount()"><i class="fa fa-address-book-o"></i> Account <label v-if="mobileConfirmedComp" class="badge badge-error">1</label> </a></li>
                  <li  v-if="compUserRole!=sitter"><a href="javascript:;" @click="goFindSitters()"><i class="fa fa-search"></i> Search Sitters</a></li>
                  <li v-if="compUserRole==customer"><a href="javascript:;" @click="goPetsView()"><i class="fa fa-paw"></i> My Pets</a></li>
                  <li v-if="compUserRole==sitter"><a href="javascript:;" @click="goSitterProfileEdit()"><i class="fa fa-address-card-o"></i> Profile Setup</a></li>
                  <li v-if="compUserRole==sitter"><a href="javascript:;" @click="goSitterReservations()"><i class="fa fa-bookmark-o"/>  Bookings</a></li>
                  <li v-if="compUserRole==sitter"><a href="javascript:;" @click="goCalendar()"><i class="fa fa-calendar "></i> Update Calendar </a></li>
                  <li v-if="compUserRole==sitter"><a href="javascript:;" @click="goDashboard()"><i class="fa fa-globe "></i> Dashboard</a></li>
                  
                  <li v-if="compUserRole==customer"><a href="javascript:;" @click="goMyReservations()"><i class="fa fa-bookmark-o"/> Bookings</a></li>
                  <li v-if="compUserRole==customer"><a href="javascript:;" @click="goFavoriteSitters()"><i class="fa fa-check-circle-o"></i> My Favorite Sitters</a></li>
                  <li v-if="compUserRole==customer"><a class="text-success" style="font-weight:600" href="javascript:;" @click="goBecomeSitter()"><i class="fa fa-heart-o" style="font-weight:600"></i> Become a Sitter</a></li>
                  <li  v-if="compUserRole=='Client' && subscriptionStatusComp==false"><a style="color:green; !important" href="javascript:;" @click="goSubscribe()"><i class="fa fa-credit-card"></i> Subscribe</a></li>
                  <li  v-if="compUserRole=='Sitter' && subscriptionStatusComp==false && !singaporeComp"><a style="color:rgb(147, 111, 159) !important" href="javascript:;" @click="goSubscribe()"><i class="fa fa-paw"></i> Go Premium</a></li>
                  <li v-if="compUserRole==sitter"><a href="javascript:;" @click="goToSitterProfile()">View Public Profile</a></li>
                  <li v-if="compUserRole==admin"><a href="javascript:;" @click="goUsersDashboard()">Users Dashboard</a></li>
                  <li v-if="compUserRole==admin"><a href="javascript:;" @click="goSittersDashboard()">Sitters Dashboard</a></li>
                  <li v-if="compUserRole==admin"><a href="javascript:;" @click="goBookingsDashboard()">Bookings Dashboard</a></li>
                  <li v-if="compUserRole==admin"><a href="javascript:;" @click="goChartsDashboard()">Charts Dashboard</a></li>
                  <li v-if="compUserRole==admin"><a href="javascript:;" @click="goTicketsDashboard()">Tickets Dashboard</a></li>
                  <li v-if="compUserRole==admin"><a href="javascript:;" @click="goCustomEmailDashboard()">Custom Email Dashboard</a></li>
                  
                  <hr style="padding:0px; margin:0px">
                  <li><a href="javascript:;" @click="logout()"><i class="fa fa-sign-out"></i> Sign Out</a></li>
          </ul>
          <ul class="nav navbar-nav" v-if="!checkUser">
            
                <li>
                   <a href="https://www.dupaws.com/pub/about" class="navbar-link"> About Us</a>
                 </li>
                  
                 <router-link v-if="checkUser==false" active-class="active" tag="li" to="/login">
                   <a>Sign In</a>
                 </router-link>
                 <router-link v-if="checkUser==false" active-class="active" tag="li" to="/findsitters">
                   <a> Search Sitters <i class="fa fa-search"></i></a>
                 </router-link>
                 <router-link v-if="compUserRole!=sitter" active-class="active" tag="li" to="/become-a-sitter">
                   <a style="font-weight:600">Become a Sitter <i style="font-weight:600" class="fa fa-heart-o"></i></a>
                 </router-link>
            </ul>
            </div> <!--remove all the options if it's an admin-->
        </div><!--/.nav-collapse -->
      
      
  </div>
</nav>

 <div v-if="mobileConfirmedComp && compUserRole!='Sitter'" class="hidden-xs hidden-sm alert text-center alert-dismissible alert-success" role="alert" style="margin-bottom: 0px; padding-top:5px; padding-bottom:5px;">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <span class="h4" ><i class=" fa fa-bell-o" v-bind:class="{'animated swing':reminderClass }"></i>  Please verify your Mobile number to receive SMS updates, visit <a class="h4" @click="goAccount()" href="javascript:;"><strong>Account</strong></a></span>
  </div>
  
<div v-if="mobileConfirmedComp && compUserRole!='Sitter'" class="hidden-lg hidden-md alert text-center alert-dismissible alert-success" role="alert" style="margin-bottom: 0px; padding-top:5px; padding-bottom:5px;">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <span class="h4" ><i class=" fa fa-bell-o" v-bind:class="{'animated swing':reminderClass }"></i>  Verify Mobile to get SMS updates <a class="h4" @click="goAccount()" href="javascript:;"><strong>Account</strong></a></span>
  </div>

 
 <div v-if="sitterPremiumComp==false" class="hidden-xs hidden-sm alert text-center alert-dismissible alert-info" role="alert" style="margin-bottom: 0px; padding-top:5px; padding-bottom:5px;">
            <button @click="hidePremium()" type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <span class="h4" style="cursor:pointer" @click="goSubscribe()">Go Premium <i style="font-size:20px;" class=" fa fa-paw" v-bind:class="{'animated bounceIn':reminderClass }"></i></span>
  </div>
  
<div v-if=" sitterPremiumComp==false" class="hidden-lg hidden-md alert text-center alert-dismissible alert-info" role="alert" style="margin-bottom: 0px; padding-top:5px; padding-bottom:5px;">
            <button @click="hidePremium()" type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <span class="h4" @click="goSubscribe()"> Go Premium <i style="font-size:20px;" class=" fa fa-paw" v-bind:class="{'animated pulse':reminderClass }"></i> </span>
  </div>


    



  <router-view></router-view>
  
    </div>

    <footer id="footer" class="page-footer paw-footer" style="margin-top:20px;">
      <div class="container-fluid main-footer">
      <div class="container center-block">
        
          <div class="col-sm-3 col-xs-6">
          
              
              <h4 class="text-muted small-h4">Quick Links</h4>
              <h5 v-if="!doubleRoleComp" ><a style="font-weight:600" href="/become-a-sitter"> Become a Sitter <i class="fa fa-heart-o" style="font-weight:600;font-size:smaller"/> </a></h5>
              <h5><a href="https://www.dupaws.com/findsitters"> Search Sitters <i class="fa fa-search"></i></a></h5>
              <h5><a href="https://www.dupaws.com/pub/reviews">Customer Reviews</a></h5>
              <h5><a href="https://www.dupaws.com/pub/training">Brain Dog Training</a></h5>
              <h5 v-if="checkUser!=true"><a href="javascript:;" @click="goLogin()">Sign In</a></h5>
              <h5><a href="javascript:;" @click="goToSupport()"> Contact Support <i class="fa fa-support"></i></a></h5>
          </div>
             <div class="col-sm-3 col-xs-6">
            <h4 class="text-muted small-h4" >Dupaws Info</h4>
            <h5><a href="https://www.dupaws.com/pub/about">About Us</a></h5>
              <h5><a href="https://www.dupaws.com/pub/faq">Frequently Asked Questions</a></h5>
              <h5><a href="mailto:info@dupaws.com"><i class="fa fa-envelope-o"/> info@dupaws.com</a></h5>
              <h5><a href="javascript:;" @click="goTerms()">Terms and Conditions</a></h5>
              <h5><a href="javascript:;" @click="goPrivacy()">Privacy Policy</a></h5>
          </div>
          <div class="col-xs-12 col-sm-6 remove-margins">
          <div class="col-sm-6 col-xs-6">
            <h4 class="text-muted small-h4">Top Countries </h4>
                     <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/united-arab-emirates"> United Arab Emirates </a></h5>
                      </div>
                      
                      <div >
                          <h5><a href="https://www.dupaws.com/pub/sitters/lebanon"> Lebanon </a></h5>
                      </div>
                      <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/qatar"> Qatar</a></h5>

                      </div>
                      <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/bahrain"> Bahrain</a></h5>
                      </div>
                      <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/singapore"> Singapore</a></h5>
                      </div>
                      <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/kuwait"> Kuwait</a></h5>
                      </div>
             
          </div>
          
          <div class="col-sm-6 col-xs-6">
              <h4 class="text-muted small-h4">Top Cities</h4>
               <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/united-arab-emirates/dog-boarding-in-dubai">  Dubai </a></h5>
                      </div>
                      <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/united-arab-emirates/dog-boarding-in-abu-dhabi">  Abu Dhabi </a></h5>
                      </div>
                      <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/united-arab-emirates/dog-boarding-in-sharjah"> Sharjah </a></h5>
                      </div>
                      <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/qatar/dog-boarding-in-doha">  Doha </a></h5>
                      </div>
                      <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/lebanon/dog-boarding-in-beirut"> Beirut</a></h5>
                      </div>
                      <div >
                              <h5><a  href="https://www.dupaws.com/pub/sitters/jordan/dog-boarding-in-amman">  Amman</a></h5>
                      </div>
                      
               
          </div>
          
          </div>

        </div>
          
          
        </div>
        
        <div class="container text-center text-muted">
        <br>
        <hr style="max-width:600px;">
                  <div class="col-sm-12 col-xs-12">
          <div class="text-center">
                <div class="center-block" style="margin-left:-4px;">
                        <p style="margin-bottom:2px;" class="text-center">Send link to a friend</p>
                        <a style="cursor:pointer" target="_top" href="javascript:;" @click="shareFacebook(myQuoteComp)"> <i id="social-fb" class="fa fa-facebook fa-2x social"></i></a>
                          <a @click="shareTwitter()" style="cursor:pointer" target="_top" :href="twitterUrl">
                            <i id="social-tw" class="fa fa-twitter fa-2x social"></i>
                        </a>
                        <a  style="cursor:pointer" @click="shareLinkedin()" target="_top" :href="linkedinUrl"><i id="social-ln" class="fa fa-linkedin fa-2x social"></i></a>
                        <a style="cursor:pointer" @click="shareGooglePlus()" target="_top" :href="googleUrl"><i id="social-gp" class="fa fa-google-plus fa-2x social"></i></a>
                        <a @click="shareWhatsApp()" class="hidden-md hidden-lg" :href="whatsappUrl" data-action="share/whatsapp/share"><i id="social-wa" class="fa fa-whatsapp fa-2x social"></i></a>
                        <a @click="shareMail()" style="cursor:pointer; color:#fd7e14" target="_top"  :href="mailUrl">
                                <i id="social-em" class="fa fa-envelope-square fa-2x social"></i>
                        </a>
            </div>
          </div>

        <h5 class="text-muted">All rights reserved &copy; Dupaws.com 2018</h5>
        
        </div>
      </div>
    </footer>
  </div>
</template>

<script>


import store from './data/store'
import auth from './auth/'
import commonApi from './services/commonApi'
import sitterApi from './services/sitterApi'
import customerApi from './services/customerApi'
import Notifications from './components/SharedComponents/Notifications'
import router from './router/index.js'

export default {
data () {
        return {
            alert: '',
            authenticated: false,
            sitter: "Sitter",
            customer: "Client",
            admin: "Admin",
            connection: '',
            refreshInterval: '',
            reminderClass: false,
            heartClass: false,
            chatHub: '',
            mobileDropdown: 'mobileDropdown',
            webDropdown: 'webDropdown',
            active: false
      }
},

methods: {
  checkStatus: function(connectionId){
    var self = this
      this.refreshInterval = setInterval(function(){
           $.ajax({
            type: 'GET',
             beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
            },
            url: 'https://www.dupaws.com/services/public/checkStatus/' + connectionId,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            success: function(data) {
                console.log(data)
                if (data==-1){
                  self.logout()
                }
                if (data.Manifest!=null){
                    if (localStorage.getItem('manifest')!=null && localStorage.getItem('manifest')==data.Manifest){
                        //do nothing as manifest in sync
                    }
                    else if (localStorage.getItem('manifest')==null){
                      localStorage.setItem('manifest', data.Manifest)
                    } else if (localStorage.getItem('manifest')!=data.Manifest){
                      localStorage.setItem('manifest', data.Manifest) //updating manifest with new version.
                      location.reload()
                    } else {
                      console.log('unknown error with manifest')
                    }

                } else {
                  console.log('manifest was null')
                }
                
            },
            error: function(data) {
                try {
                  if (data.status==401){ //means the authorization failed for some reason..
                    swal({
                        title: "Session disconnected from server",
                        text: data.responseJSON.Message,
                        type: "info",
                        confirmButtonClass: 'btn-success',
                        confirmButtonText: "Logout and login again to continue",
                        closeOnConfirm: true,
                        html: true
                      }, function(){
                        self.logout()
                      });

                  } else {
                  swal("Session disconnected from server", "Your session has been disconnected, please refresh the page to continue.", "info")
                  }
                
                } catch (e) {
                    swal("Session disconnected from server with unknown error", "Your session has been disconnected, please check your network settings.", "info")
                }
            }
        });
      }, 30000)
  },
  getSessionId() {
    if (sessionStorage.getItem("SessionId")==null) {
  var uuid = guid();
  sessionStorage.setItem("SessionId", uuid)
  return uuid;
  } 
  else{
    return sessionStorage.getItem("SessionId");
  }


  function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  },
  getNewCountry(){
    var self =this
     $('#selectCountry').modal('hide');
     swal({
  title: "Enter country name below",
  type: "input",
  showCancelButton: true,
  closeOnConfirm: false,
  inputPlaceholder: "Country Name"
  }, function (inputValue) {
    if (inputValue === false) return false;
    if (inputValue === "") {
      swal.showInputError("Oops, please write your country name and press OK");
      return false
    }
    self.addCountry(inputValue)
    return

  });
  },
  shareLinkedin: function(){
    this.$ga.event('Share Button Clicked', 'linkedin', 'https://www.dupaws.com')
  },
  shareWhatsApp: function(){
    this.$ga.event('Share Button Clicked', 'whatsup', 'https://www.dupaws.com')
  },
  shareGooglePlus: function(){
    this.$ga.event('Share Button Clicked', 'google+', 'https://www.dupaws.com')
  },
  shareMail: function(){
    this.$ga.event('Share Button Clicked', 'mail', 'https://www.dupaws.com')
  },
  shareFacebook: function(myQuoteComp){
        this.$ga.event('Share Button Clicked', 'facebook', 'https://www.dupaws.com')
          var self = this
          FB.ui({
              method: 'share',
              href: 'https://www.dupaws.com',
              quote: myQuoteComp,
              hashtag: '#dupaws',
              mobile_iframe: true,
              }, function(response){
                      if (response && !response.error_message){
                          
                      }
                      else {
              }
          });
  },
  addCountry(countryName){
    var self = this
     return $.ajax({
            type: 'GET',
            url: 'https://www.dupaws.com/services/public/suggestCountry/' + countryName,
            dataType: "json",
            crossDomain: true,
            contentType: "application/json; charset=utf-8",
            success: function(data) {
                swal("Thank you", "Country: " + countryName + " has been sent to our system, we will direct you to UAE country now to see how the website works", "success");
                localStorage.setItem('CountryId', 1)
                commonApi.initCountry()
            },
            error: function(data, status, error) {
                console.log("Couldn't retrieve sitter through initSitterData() call: " + data.responseText)
            }
        })
  },
  goToSupport(){
    this.closeNavbarIfOpen()
    router.push({
      path: '/contact-support',
      force: true
    })
  },
  routerGoHome(){
    this.closeNavbarIfOpen()
    if (router.currentRoute.name=="home")
      router.go('/')
      
    router.push({
      path: '/',
      force: true
    })
  },
  mouseOver: function(){
    if (this.pulse == '')
      this.pulse ='animated pulse'
    else 
      this.pulse = ''
    
  },
  closeNavbarIfOpen(){
     $('#navbar').collapse('hide') //bootstrap 3.x by Richard
  },
  goMyReservations(){
    this.closeNavbarIfOpen()
    router.push({
      path: '/my-reservations/',
      force: true
    })
  },
  goSitterReservations(){
    this.closeNavbarIfOpen()
    router.push({
      path: '/my-sitter-reservations',
      force: true
    })
  },
  setCountry: function(countryId){
      $('#selectCountry').modal('hide');
       setTimeout(function(){
                 localStorage.setItem("CountryId", countryId)
                commonApi.initCountry()
                router.go('/')
            }, 200)
     
  },
  goDashboard(){
    this.closeNavbarIfOpen()
    router.push({
      path: '/dashboard/feedback-performance',
      force: true
    })
  },
  goCalendar(){
    this.closeNavbarIfOpen()
    router.push({
      path: '/sitter-profile-edit/calendar',
      force: true
    })
  },
  goSitterProfileEdit(){
    this.closeNavbarIfOpen()
    router.push({
      path: '/sitter-profile-edit/about',
      force: true
    })
  },
  logout(){
    this.closeNavbarIfOpen()
    auth.logout()
    router.push({path: '/login'})
    router.go({path: '/login'}) //workaround for refreshing the page and keeping path at /login.. dirty stuff...
  },
  goFindSitters(){
    this.closeNavbarIfOpen()
    router.push({path: '/findsitters'})
  },
  goAccount(){
    this.closeNavbarIfOpen()
    router.push({path: '/account', force: true})
  },
  goSubscribe(){
    this.closeNavbarIfOpen()
    router.push({path: '/subscribe', force: true})
  },
  hidePremium(){
    localStorage.setItem('hidePremium', JSON.stringify(moment()))
  },
  goPetsView(){
    this.closeNavbarIfOpen()
    router.push({path: '/pets-view/mypets'})
  },
  goFavoriteSitters(){
    this.closeNavbarIfOpen()
    router.push({path: '/favorite-sitters'})
  },
  showCountries(){
    if (this.compUserRole=='Sitter')
          swal("Oops", "Sorry you cant change country while logged in as a Sitter, please contact support to change your details.", "info")
    else 
      $('#selectCountry').modal('show');
  },
  goBecomeSitter(){
    this.closeNavbarIfOpen()
    router.push({path: '/become-a-sitter'})
  },
  goToSitterProfile(){
    this.closeNavbarIfOpen()
    if (this.$route.params.sitterId==null){
      if (router.path="/sitter-profile-edit/about")
         router.push({path: '/'})   //Workaround to Vue Router issue not redirecting to sitter public profile.
      router.push({path: this.sitterIdComp})
      }
  },
  goUsersDashboard(){
    this.closeNavbarIfOpen()
    router.push({path: '/users-dashboard'})
  },
  goSittersDashboard(){
    this.closeNavbarIfOpen()
    router.push({path: '/sitters-dashboard'})
  },
  goTicketsDashboard(){
    this.closeNavbarIfOpen()
    router.push({path: '/tickets-dashboard'})
  },
  goCustomEmailDashboard(){
    this.closeNavbarIfOpen()
    router.push({path: '/email-dashboard'})
  },
  goChartsDashboard(){
    this.closeNavbarIfOpen()
    router.push({path: '/charts-dashboard'})
  },
  goBookingsDashboard(){
    this.closeNavbarIfOpen()
    router.push({path: '/bookings-dashboard'})
  },
  goTerms(){
     router.push({path: '/terms-and-conditions'})
  },
  goAbout(){
     router.go({path: 'https://www.dupaws.com/pub/about'})
  },
  goPrivacy(){
     router.push({path: '/privacy-policy'})
  },
  goLogin(){
     router.push({path: '/login'})
  },
  
  
  
},
watch: {
  'selectCountryComp': function(){
      if (this.selectCountryComp==true)
        $('#selectCountry').modal('show');
      else 
        $('#selectCountry').modal('hide');
  }
},
updated: function(){
  var self = this
    setTimeout(function(){
                if (self.reminderClass==true)
                 self.reminderClass = false
                else 
                 self.reminderClass = true

        }, 15000)

  if (self.checkUser==true)
    if (store.getters.email && self.compUserName)
    {
    // $zopim(function() {
    //   $zopim.livechat.setName(self.compUserName);
    //   $zopim.livechat.setEmail(store.getters.email);
    //   $zopim.livechat.badge.hide();
    // });
    }
  if (localStorage.getItem('profilePicUrl')!=null)
    store.commit('profilePicUrl', localStorage.getItem('profilePicUrl'))
  if (localStorage.getItem('HideZopim')==null){
  setTimeout(function(){
    // $zopim(function() {
    //     $zopim.livechat.badge.hide();
    // });
    localStorage.setItem('HideZopim','1');
    }, 5000)
  }
  else {
    // $zopim(function() {
    //     $zopim.livechat.badge.hide();
    // });
  }

  },
  mounted: function(){
    var self = this
    auth.checkTokenExpiry();
    commonApi.initCountry();
     
  

    commonApi.initStaycationData();

    $('.nav li').on('click', function(){
      $('.navbar-collapse').collapse('hide') //bootstrap 3.x by Richard
    });
  auth.checkToken()
  if (localStorage.getItem('userRole')!=null)
    store.commit('userRole', localStorage.getItem('userRole'))
  if (localStorage.getItem('profilePicUrl')!=null)
    store.commit('profilePicUrl', localStorage.getItem('profilePicUrl'))
  if (localStorage.getItem('email')!=null)
    store.commit('email', localStorage.getItem('email'))
  if (localStorage.getItem('sitterId')!=null)
    store.commit('sitterId', localStorage.getItem('sitterId'))
  if (localStorage.getItem('customerId')!=null)
    store.commit('customerId', localStorage.getItem('customerId'))

  if (localStorage.getItem('userRole')!=null)
    if (localStorage.getItem('userRole')=="Client")
    {
      customerApi.initFavoriteSitters()  
      customerApi.getPetsList()
    }
  commonApi.initQuery()    
  if (this.checkUser==true && this.compUserRole!="Admin"){
    commonApi.getNotifications(store.getters.userRole)
  }

 
  var userId
        if (store.getters.userRole=="Sitter"){
            userId = store.getters.SitterId
        }
        else if (store.getters.userRole=="Client"){
            userId = store.getters.CustomerId
  }

  self.$nextTick(function (){
 
      $('#mobileNotificationDropdown .dropdown-menu').click(function(e) {  //prevent notification from auto-close on click sub item
      e.stopPropagation();
  });
    
      $('#webNotificationDropdown .dropdown-menu').click(function(e) {
      e.stopPropagation();
  });
  
  
  self.connection = $.hubConnection('https://www.dupaws.com/services')
  // self.connection.transports.longPolling.supportsKeepAlive = function (){
  //   return false;
  // }
  
  
  self.connection.qs = {SessionId: self.getSessionId()}
  self.connection.logging = true
  self.chatHub = self.connection.createHubProxy('chatHub');       
  self.chatHub.on('SendNotification', function(userNotification){
                  store.commit('addNotification', userNotification)
              })
  self.chatHub.on('UpdateNotification', function(userNotification){
                 store.commit('updateNotification', userNotification)
              })
  
  
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    if(isAndroid) {
        self.connection.start({transport: ['longPolling']})
        .done(function(){ 
              store.commit('signalRHub', self.chatHub)          
              self.chatHub.invoke('RegisterNotification',userId,store.getters.userRole)
              if (self.checkUser)
                  self.checkStatus(self.connection.id)
              console.log('signalRHub started in longPolling mode')
              
        })
        .fail(function(){ console.error('Could not connect to SignalR'); });

    } else {
      // self.connection.start() //100% long polling from now on..
       self.connection.start({transport: ['longPolling']})
        .done(function(){ 
              store.commit('signalRHub', self.chatHub)          
              self.chatHub.invoke('RegisterNotification',userId,store.getters.userRole)
              
              if (self.checkUser)
                  self.checkStatus(self.connection.id)
              console.log('signalRHub started in autodetect mode')
              
        })
        .fail(function(){ console.error('Could not connect to SignalR'); });
    }
 
    
    store.commit('signalRConnection', self.connection)
   
       if (store.getters.authenticated){
        commonApi.initUserSubscription();
    }
  })
},
computed:{
  singaporeComp: function(){
    if (store.getters.CountryData.CountryId==9){
      return true
    } else {
      return false
    }
  },
      whatsappUrl: function(){
         
          return 'whatsapp://send?text=' + "https://www.dupaws.com"
        },
        twitterUrl: function(){
         
            return 'https://twitter.com/share?url=' + "https://www.dupaws.com" + '&via=dupaws&hashtags=dupaws'
        },
        linkedinUrl: function(){
          
            return 'https://www.linkedin.com/shareArticle?mini=true&url=' + "https://www.dupaws.com" + '&source=LinkedIn'
        },
        googleUrl: function(){
            return 'https://plus.google.com/share?url=' + "https://www.dupaws.com"
        },
        mailUrl: function(){
            return 'mailto:?subject=Checkout this great idea for your pet :)&body=' + 'https://www.dupaws.com'
        },
  mobileConfirmedComp: function(){
    var self = this
      if (self.compUserRole == "Admin" || self.checkUser==false)
        return false
      if (self.checkUser)
        if (store.getters.PhoneConfirmed==false)
            return true
        else
          return false
  },
  sitterPremiumComp: function(){
    var self = this
    if (!store.getters.SubscriptionStatus){
      return true
    }
    if (self.checkUser==false || self.compUserRole!='Sitter'){ //dont prompt premium for clients or non-logged users.
      return true
    }
    if (self.$route.name=='subscribe'){
      return true
    }
    if (self.compUserRole == "Sitter" && store.getters.SubscriptionStatus.IsActive==true){ //dont prompt already subscribed sitters.
      return true
    }
    if (localStorage.getItem('hidePremium')!=null){  //dont prompt sitters who closed the alert during the past 7 days.
        var hideTime  = moment(JSON.parse(localStorage.getItem('hidePremium')))
        var now = moment()
        var diff = now.diff(hideTime, 'days')
        if (diff>60){
          return false
        } 
        else {
          return true
        }
    }
   
    return false
  },  
    doubleRoleComp: function(){
      if (localStorage.getItem('doubleRole') == "True" || this.compUserRole == "Sitter")
        return true
      else  
        return false
    },
    checkUser: function(){
        return store.getters.authenticated
    },
    compUserName: function(){
      if (store.getters.firstName && store.getters.lastName)
        return store.getters.firstName + ' ' +  store.getters.lastName
      else if (localStorage.getItem('firstName')!=null && localStorage.getItem('lastName')!=null)
        return localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName')
      else 
        return "Guest"
    },
    compUserRole: function(){
       return store.getters.userRole
    },
    compProfilePicUrl: function(){
      if (store.getters.profilePicUrl!=null){
      return store.getters.profilePicUrl
      } else {
      return localStorage.getItem('profilePicUrl')
      }
    },
    countryDataComp: function(){
      return store.getters.CountryData
    },
    sitterIdComp: function(){
      if (store.getters.SitterId!=null){
        return 'sitter/' + store.getters.SitterId
      }
                
    },
    signalReady: function(){
          if (store.getters.SignalRHub!=null)
              if (store.getters.SignalRHub.connection!=null) 
                  return true
          return false;

    },
    countryDataComp: function(){
       return store.getters.CountryData
     },
     countriesList: function(){
       return store.getters.CountriesList
     },
     selectCountryComp: function(){
       return store.getters.SelectCountry
     },
    myQuoteComp: function(){
       return 'Dupaws Pet Boarding at Homes available in ' + this.countryDataComp.CountryName
     },
     subscriptionStatusComp: function(){
       return store.getters.SubscriptionStatus.IsActive
     }
     
},
beforeDestroy: function(){
   var self = this
   clearInterval(this.refreshInterval)
},
components: {
  Notifications
}


}



</script>



<style scoped>

.tinted { filter: brightness(90%);}

.social:hover {
     -webkit-transform: scale(1.1);
     -moz-transform: scale(1.1);
     -o-transform: scale(1.1);
 }
 .social {
     -webkit-transform: scale(0.8);
     /* Browser Variations: */
     
     -moz-transform: scale(0.8);
     -o-transform: scale(0.8);
     -webkit-transition-duration: 0.5s;
     -moz-transition-duration: 0.5s;
     -o-transition-duration: 0.5s;
 }

/*
    Multicoloured Hover Variations
*/
 
 #social-fb {
     color: #3B5998;
 }
 #social-tw {
     color: #4099FF;
 }
 #social-gp {
     color: #d34836;
 }
 #social-ig {
     color: #974250;
 }

#social-wa {
    color:#4dc85c;
}

.page-footer{
  background-color:#f1f1f1;
}

.main-body{
  color:#6c6b6b;
  line-height:1.5;
  
  width: 100%;
  

}

.navbar-fixed-top {
    min-height: 10px !important;
}

.paw{ 
   background-image: url("./components/Sitters/images/paw.png");
    background-size: contain;
    width: 100%;
  background-size: 70px;
    
}

h5 a {
  font-size:1em !important;
}


a, .a{
      font-family: 'Yanone Kaffeesatz', sans-serif;
    /* word-spacing: 00.09em; */
    font-size: 24px;
}


.navbar-brand 
  {
      padding-top: 5px;
  }

.navbar{
  margin-bottom: 0px;
}

.navbar-nav > li > a {
    padding-top: 0px;
    padding-bottom: 0px;
    line-height: 60px;
}

.nav > li > a{
  padding: 5px 20px;
}

@media (max-width: 767px) {
    .navbar-nav > li > a {
    line-height: 20px;
    padding-top: 10px;
    padding-bottom: 10px;}
}

.container-fluid {
  padding-left: 0px;
  padding-right: 0px;
}

.container-main{
  padding-left: 1vw;
  padding-right: 1vw;
}

.paw-footer{
     background-image: url("./components/Sitters/images/paw.png");
    background-size: 70px;
    width: 100%;
    
}


.modal {
  text-align: center;
}

 .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.alert-premium{
      background-color: #cfc1d4;
    border-color: #b791c3;
    color: #8d5c9c;

}

.badge {
  margin-left:5px;
  
}


.badge-error {
  background-color: #b94a48;
}


</style>



// WEBPACK FOOTER //
// App.vue?d48bd920